import type { UntitledIconData } from '../../UntitledIconData'

const usAttachment02: UntitledIconData = {
  prefix: 'us',
  name: 'attachment-02',
  paths: [
    {
      shape:
        'M10.1667 3C8.69391 3 7.5 4.19391 7.5 5.66667V16.5C7.5 18.9853 9.51472 21 12 21C14.4853 21 16.5 18.9853 16.5 16.5V5.25581C16.5 4.70353 16.9477 4.25581 17.5 4.25581C18.0523 4.25581 18.5 4.70353 18.5 5.25581V16.5C18.5 20.0899 15.5899 23 12 23C8.41015 23 5.5 20.0899 5.5 16.5V5.66667C5.5 3.08934 7.58934 1 10.1667 1C12.744 1 14.8333 3.08934 14.8333 5.66667V16.4457C14.8333 18.0105 13.5648 19.2791 12 19.2791C10.4352 19.2791 9.16667 18.0105 9.16667 16.4457V6.65116C9.16667 6.09888 9.61438 5.65116 10.1667 5.65116C10.719 5.65116 11.1667 6.09888 11.1667 6.65116V16.4457C11.1667 16.906 11.5398 17.2791 12 17.2791C12.4602 17.2791 12.8333 16.906 12.8333 16.4457V5.66667C12.8333 4.19391 11.6394 3 10.1667 3Z',
    },
  ],
}

export default usAttachment02
